var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import AddStrategy from "~/components/system-manage/outsource-commission/add-strategy.vue";
import { PageService } from "~/utils/page.service";
import { CommissionStrategyService } from "~/services/domain-service/commission-strategy.service";
import { SortService } from '~/utils/sort.service';
var OutSourceCommission = /** @class */ (function (_super) {
    __extends(OutSourceCommission, _super);
    function OutSourceCommission() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 默认弹框是增加
        _this.dialogType = "ADD";
        // 数据列表
        _this.dataSet = [];
        // 当前行数据
        _this.rowData = null;
        // 弹框控制
        _this.dialog = {
            openAddStrategy: false,
        };
        _this.model = {
            strategyName: '',
            commissionStrategyType: '',
            commonState: ''
        };
        return _this;
    }
    OutSourceCommission.prototype.refreshData = function () {
        var _this = this;
        this.commissionStrategyService.getCommissionStrategyList(this.model, this.pageService).subscribe(function (data) { return _this.dataSet = data; });
    };
    OutSourceCommission.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(CommissionStrategyService)
    ], OutSourceCommission.prototype, "commissionStrategyService", void 0);
    __decorate([
        Dependencies(PageService)
    ], OutSourceCommission.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OutSourceCommission.prototype, "sortService", void 0);
    OutSourceCommission = __decorate([
        Auth(17),
        Layout("workspace"),
        Component({
            components: {
                AddStrategy: AddStrategy
            }
        })
    ], OutSourceCommission);
    return OutSourceCommission;
}(Vue));
export default OutSourceCommission;
